// extracted by mini-css-extract-plugin
module.exports = {"container":"styleUserMenu_container__3aMaO","avatar":"styleUserMenu_avatar__H47Or","name":"styleUserMenu_name__2cxjG"};